import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { SsrService } from '@finder/shared/services/ssr/ssr.service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { Observable } from 'rxjs';

@Injectable()
export class SendURIInterceptor implements HttpInterceptor {
    private injector = inject(Injector);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // this will work for SSR and browser
        const winRef = this.injector.get(WindowRef);
        const ssrService = this.injector.get(SsrService);

        if (!ssrService.allowMetaData() || ssrService.isBrowser()) {
            return next.handle(req);
        }

        /**
         * this will send the current URL to the API server so we can create a canonical url
         */
        const newReq = req.clone({
            setHeaders: {
                'X-Disney-Current-URI': winRef.nativeWindow.location.href
            }
        });

        return next.handle(newReq);
    }
}
